import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../environments/environment";

import { LookupService } from "../../services/lookups/lookup.service";

import { AuthService } from "../../services/auth/auth.service";
import { Subscription } from "rxjs/Subscription";
import { NotificationComponent } from "../shared/notification.component";
import { LocalStorageService } from "../../services/shared/localStorage.service";

import { PopUpDialogComponent } from "../../components/anon/popup-dialog.component";
import { PopupComponent } from '@progress/kendo-angular-popup';

//import { tokenNotExpired } from "angular2-jwt";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit, OnDestroy {
    @ViewChild('notification') notificationComponent: NotificationComponent;
  
    frm: FormGroup;

    loggedIn: boolean = false;
    
    returnUrl: string;

    constructor(private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
        private lookupService: LookupService,
        private lsService: LocalStorageService,
        private dialog: PopUpDialogComponent,
        private ls: LookupService
        ) { }

    onAuthenticationChanged: Subscription;
    onFormValueChanged: Subscription;

    loading: boolean = false;
    showRememberMe: boolean = false;
    defaultRedirectRoute: string = this.ls.getDefaultRedirectRoute();
 

  ngOnInit() {
        
        this.loggedIn = this.authService.isAuthenticated();
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || this.defaultRedirectRoute;
    
        this.showRememberMe = this.lookupService.getShowRememberMe();

        let ru: { userName: string, pwd: string, rememberMe: boolean } = { userName: "", pwd: "", rememberMe: false };
        if (this.showRememberMe) {
            ru = this.lsService.getRememberedUser();
        }

        this.frm = new FormGroup(
            {
                'username': new FormControl(ru.userName, [Validators.required, Validators.email]),
                'password': new FormControl(ru.pwd, Validators.required),
                'rememberMe': new FormControl(ru.rememberMe),
            }
        );

        this.onFormValueChanged = this.frm.valueChanges.subscribe(data => { this.notificationComponent.clear(); })

        this.onAuthenticationChanged = this.authService.authenticationChanged
            .subscribe(
            () => {
                this.loggedIn = this.authService.isAuthenticated();
                if (this.loggedIn) { 
                    this.router.navigate([this.returnUrl]);
                    //this.isAgreedToTermsOfService = this.authService.getUser().isAgreed;
                } else {
                    const errorMessage = this.authService.getErrorMessage();
                  this.notificationComponent.animateErrorAction(errorMessage);
                }
                this.loading = false;
              });
   }

    ngOnDestroy() {
        this.onAuthenticationChanged.unsubscribe();
        this.onFormValueChanged.unsubscribe();
    }

    onLogin() {

      this.loading = true;

      const username = this.frm.value.username;
      const password = this.frm.value.password;
      const rememberMe = this.frm.value.rememberMe;

      this.authService.login(username, password, rememberMe, this.returnUrl);

    }

    onClear() {
        this.frm.value.username = null;
        this.frm.value.password = null;
        this.frm.value.rememberMe = false;

        this.frm.reset();
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/anon/login.component.ts